import ContactUs from "./ContactUs";
import "./styles.scss";

export default {
  ContactUs,
};
